'use strict';
const moment = require('moment');
const { SITUACAO_EXAME, SITUACAO_LAUDO } = require('../constantes');

const getCorLegenda = (exame, dispMovel = false) => {
    const { situacao, situacao_laudo, origem, possui_imagem, data_exame, data_priorizacao, possui_assinatura_digital } = exame;

    // Exame inválido
    if (situacao !== SITUACAO_EXAME.VALIDO) {
        return dispMovel ? '#721E1E' : '#eb9191';
    }

    // Exame válido
    switch (situacao_laudo) {
        case SITUACAO_LAUDO.TEMPORARIO:
        case SITUACAO_LAUDO.AGUARDANDO_ASSINATURA_DIGITAL:
            return dispMovel ? '#865829' : '#fce5cd';

        case SITUACAO_LAUDO.AGUARDANDO_COMPLEMENTO:
            return dispMovel ? '#7C4C1B' : '#fbd7b1';

        case SITUACAO_LAUDO.EM_EMISSAO:
            return dispMovel ? '#206021' : '#d9ead2';

        case SITUACAO_LAUDO.SEM_LAUDO:
            const hoje = moment();
            const exameMais3Dias = moment(data_exame).add(3, 'days');

            if (origem === 'I' && possui_imagem === 'N') {
                return dispMovel ? '#7C4C1B' : '#fbd7b1';
            }
            if (data_priorizacao) {
                return dispMovel ? '#623232' : '#f4cbcb';
            }
            if (exameMais3Dias.isAfter(hoje)) {
                return dispMovel ? '#325374' : '#cee1f4';
            }
            return dispMovel ? '#6B671A' : '#faf7a9';

        case SITUACAO_LAUDO.COM_LAUDO:
        case SITUACAO_LAUDO.COM_LAUDO_APP:
            return dispMovel ? '#206021' : '#b0d8b1';

        default:
            return dispMovel ? '#325374' : '#cee1f4';
    }
};

const getCorLegendaLaudoGrave = (linha, dispMovel = false) => {
    if (linha.situacao === 'Visualizado') return dispMovel ? '#206021' : '#b0d8b1';

    if (linha.situacao === 'Verificado') return dispMovel ? '#6B671A' : '#faf7a9';

    return dispMovel ? '#721E1E' : '#ea9999';
};

const getTextoLegenda = (linha, strings) => {
    const valido = linha.situacao === 'V';

    if (!valido) return strings.invalido;

    if (linha.origem === 'I' && linha.possui_imagem === 'N' && linha.situacao_laudo === 'N') return strings.agendado;

    if (linha.situacao_laudo === 'T' || linha.situacao_laudo === 'D' || linha.situacao_laudo === 'G') return strings.laudoTemporario;

    if (linha.situacao_laudo === 'N') {
        if (linha.data_priorizacao) return strings.priorizado;

        const hoje = moment();
        const exameMais3Dias = moment(linha.data_exame).add(3, 'days');
        if (exameMais3Dias.isAfter(hoje)) return strings.semLaudo;

        return strings.semLaudo72h;
    }

    if (linha.situacao_laudo === 'S' || linha.situacao_laudo === 'M') return strings.comLaudo;

    if (linha.situacao_laudo === 'E') return strings.laudoEmissao;

    if (linha.situacao_laudo === 'A') return strings.laudoAguardandoComplemento;

    return strings.semLaudo;
};

module.exports = { getCorLegenda, getTextoLegenda, getCorLegendaLaudoGrave };
